/*
 * "L is op in deze kleur. Wel in L: Zwart, Groen." (PDP-#54)
 *
 * When the visitor taps a size that is sold out in this colour, the line
 * under the sizes names the colours of the same design that still have that
 * size, as links. The colours come from the colour row on the page
 * (snippets/color-siblings.liquid puts each sibling's available sizes in
 * data-sizes), so nothing is promised that the row does not know. 49 Bol
 * cases a season ask exactly this (docs/wp/KLANTVRAGEN-DEKKING-2026-10-08.md).
 */
(function () {
  const line = document.querySelector('[data-size-alternatives]');
  if (!line) return;
  const scope = line.closest('.product-info') || document;

  function siblingsWith(size) {
    return [...document.querySelectorAll('.color-siblings__link[data-sizes]')]
      .filter((link) => link.dataset.sizes.split('|').includes(size))
      .map((link) => ({ href: link.href, label: link.querySelector('.color-siblings__label')?.textContent.trim() || link.title }));
  }

  function render() {
    const chosen = scope.querySelector('input.opt-btn:checked');
    if (!chosen) return hide();
    // The theme's variant picker marks the INPUT, not the label (variant-picker.js).
    const soldOut = chosen.disabled || chosen.classList.contains('is-unavailable');
    if (!soldOut) return hide();
    const size = chosen.value;
    const siblings = siblingsWith(size);
    if (!siblings.length) return hide();
    const label = scope.querySelector(`label[for="${chosen.id}"]`);
    const shown = label ? label.textContent.trim() : size;
    const links = siblings.map((s) => `<a href="${s.href}">${s.label}</a>`).join(', ');
    line.innerHTML = line.dataset.text.replace(/\[size\]/g, shown).replace('[colors]', links);
    line.hidden = false;
  }

  function hide() {
    line.hidden = true;
  }

  // The theme marks a size unavailable right after the change event; wait a tick.
  scope.addEventListener('change', (event) => {
    if (event.target.matches('input.opt-btn')) setTimeout(render, 60);
  });
  setTimeout(render, 300);
})();
